import { CommodityDto } from '@billing/app/api'
import { clearFilterField, TomTableAdvancedFilterChipProps } from '@tom-ui/ui'
import { action, computed, makeObservable, observable } from 'mobx'

export interface CommodityFilterFormData {
  selectable?: boolean
  active?: boolean
}

export class CommodityFilterUIStore {
  filter: CommodityFilterFormData = {}

  constructor() {
    makeObservable(this, {
      filter: observable,

      setFilter: action,
      clearFilterValue: action,

      filtersInUse: computed,
    })
  }

  public setFilter(filter?: CommodityFilterFormData) {
    if (!filter) {
      this.filter = {}
    } else {
      this.filter = filter
    }
  }

  public clearFilterValue(propertyKey: string): void {
    clearFilterField(propertyKey, this.filter)
  }

  public get filtersInUse() {
    const filtersMap: TomTableAdvancedFilterChipProps<CommodityFilterFormData>[] = []

    if (this.filter.active !== undefined && this.filter.active !== null) {
      filtersMap.push({
        propertyKey: 'active',
        translationKey: 'active',
        value: this.filter.active,
      })
    }

    if (this.filter.selectable !== undefined && this.filter.selectable !== null) {
      filtersMap.push({
        propertyKey: 'selectable',
        translationKey: 'selectable',
        value: this.filter.selectable,
      })
    }

    return filtersMap
  }

  public filterItems(items: CommodityDto[]) {
    if (this.filtersInUse.length === 0) {
      return items
    }

    const matchesFilter = (item: CommodityDto): boolean => {
      if (this.isActive(item) && this.isSelectable(item)) {
        return true
      }

      if (item.childCommodities && item.childCommodities.length > 0) {
        return item.childCommodities.some(child => matchesFilter(child))
      }

      return false
    }

    return items.filter(item => matchesFilter(item))
  }

  private isActive(item: CommodityDto): boolean {
    return (
      this.filter.active === undefined ||
      this.filter.active === null ||
      item.isActive === this.filter.active
    )
  }

  private isSelectable(item: CommodityDto): boolean {
    return (
      this.filter.selectable === undefined ||
      this.filter.selectable === null ||
      item.isSelectable === this.filter.selectable
    )
  }
}
